// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__Qndxo","label":"Input_label__o8Uek","required":"Input_required__TgapD","input":"Input_input__m3YZ7","error":"Input_error__CK-nE"};